import { useEffect, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import GBusinessEventPreview from './gbusiness-event-preview.component';
import GBusinessOfferPreview from './gbusiness-offer-preview.component';
import GBusinessStandardPreview from './gbusiness-standard-preview.component';

const GBusinessPreviewOrganize = ({ postType, previewData, profileId }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    if (!previewData || !profileId) return;
    let data = previewData[profileId].data;
    for (var i = 0; i < data.length; i++) {
      if (data[i].post_type === postType) {
        data[i].media_data = CommonHelper.ProcessMediaUrl(data[i].media_url);
        setData(data[i]);
      }
    }
  }, [postType, previewData, profileId]);

  return (
    <>
      {data && data?.post_type === 'STANDARD' && <GBusinessStandardPreview data={data} />}
      {data && data?.post_type === 'EVENT' && <GBusinessEventPreview data={data} />}
      {data && data?.post_type === 'OFFER' && <GBusinessOfferPreview data={data} />}
    </>
  );
};

export default GBusinessPreviewOrganize;
